RivalIQ.apps.Dashboard.module('mixins', function (mixins, App, Backbone, Marionette, $, _) {

    'use strict';

    mixins.CurationBufferedEventProxy = {
        // This method starts the cache layer buffering on a prop change, and waits
        // for all the children to have been given a chance to `loadData` before halting
        // the rendering. There's likely a better way to do this.
        proxyChangeEventsToChildren: function (changed, options) {
            const me = this;

            if (options.propagate === false) {
                return;
            }

            if (!_.isEmpty(changed) && !RivalIQ.data.CacheLayer.isBuffering()) {
                const widgets = _.get(me, 'router.controller.regions.widgetsRegion.currentView');

                if (widgets && widgets.waitForAsyncRender) {

                    RivalIQ.data.CacheLayer.startBuffering();
                    RivalIQ.universal.startBuffering();

                    App.models.Curation.prototype.proxyChangeEventsToChildren.apply(me, arguments);

                    window.requestAnimationFrame(function () {
                        widgets.waitForAsyncRender(function () {
                            RivalIQ.universal.stopBuffering();
                            RivalIQ.data.CacheLayer.stopBuffering();
                            RivalIQ.universal.flush();
                            RivalIQ.data.CacheLayer.flush();
                        });
                    });
                }
            } else {
                App.models.Curation.prototype.proxyChangeEventsToChildren.apply(me, arguments);
            }
        }
    };

    // This mixin is useful for widgets where loadData results in more than one metric load. If we weren't buffering
    // in that case, each metric load would be a separate http request. For example, in ads without buffering an N column
    // table would make N HTTP requests for ads metrics back to the server. With buffering, the cacheLayer can usually get
    // that to be just one request.
    mixins.LoadDataWithBuffering = {
        loadData: function () {
            const me = this;

            let startedBuffering = false;
            if (!RivalIQ.data.CacheLayer.isBuffering()) {
                startedBuffering = true;
                RivalIQ.data.CacheLayer.startBuffering();
                RivalIQ.universal.startBuffering();
            }

            const promise = me._loadData();

            if (startedBuffering) {
                RivalIQ.universal.stopBuffering();
                RivalIQ.data.CacheLayer.stopBuffering();
                RivalIQ.universal.flush();
                RivalIQ.data.CacheLayer.flush();
            }

            return promise;
        }
    };
});
